/****************************** HEAP CONSTANTS (passed via statsig) ********************************/
// Follow naming standards: https://eventbrite.atlassian.net/wiki/spaces/DEV/pages/15423275681/What+are+the+best+practice+naming+conventions+for+Heap+events

// General events
export const HEAP_LOCATION_STRING = 'Home - All';
export const HEAP_FEATURED_EVENTS: `${string} - ${string}` = `${HEAP_LOCATION_STRING} - Click - Featured Events`;
export const HEAP_SCROLLED_TO_BOTTOM = `${HEAP_LOCATION_STRING} - Scroll End - All`;
export const HEAP_SEE_MORE_BTN_CLICK = `${HEAP_LOCATION_STRING} - Click - See More`;
export const HEAP_TAB_CLICK = `${HEAP_LOCATION_STRING} - Click - Tab(s)`;
export const HEAP_VIEW_FOR_YOU_TAB = `${HEAP_LOCATION_STRING} - View - For You Tab`;
export const HEAP_HOMEPAGE_VIEWED = `${HEAP_LOCATION_STRING} - View - Page`;

// Buckets
export const HEAP_BUCKET_ONLOAD = 'PersonalizationBucketLoad';
export const HEAP_BUCKET_VIEW = 'personalizationBucketName';

// Horizonal Scrolling Buckets
export const HEAP_CAROUSEL_SCROLLED_TO_END = `${HEAP_LOCATION_STRING} - Scroll End - Carousel(s)`;

// Personalization Filters
export const HEAP_DATE_TEXT_FILTER_SELECTED = `${HEAP_LOCATION_STRING} - Click - Date Text Filter`;
export const HEAP_DATE_CUSTOM_FILTER_SELECTED = `${HEAP_LOCATION_STRING} - Click - Date Custom Filter`;
export const HEAP_DATE_FILTER_RESET = `${HEAP_LOCATION_STRING} - Click - Date Filter Reset`;

export enum HomeEngagementExperimentTrackingLocations {
    TAB = 'Tab',
    FOR_YOU = 'For You',
    CITY_CTA = 'City CTA',
    TRENDING = 'Trending Category',
}
